<template>
  <div>
    <table class="table table-sm">
      <thead></thead>
      <tbody>
        <tr>
          <td>RESIDENTE</td>
          <td>
            <strong>{{ service.resident_name }}</strong>
          </td>
        </tr>
        <tr>
          <td>SERVIÇO</td>
          <td>
            <strong>{{ service.service_description }}</strong>
          </td>
        </tr>
        <tr>
          <td>QUANTIDADE</td>
          <td>
            <strong>{{ service.quantity }}</strong>
          </td>
        </tr>
        <tr>
          <td>TOTAL</td>
          <td>
            <strong>{{ formatPrice(service.value_sale) }}</strong>
          </td>
        </tr>
        <!-- <tr>
          <td>REPETIR</td>
          <td>
            <strong>{{
              {
                NAO_SE_REPETE: "NÃO SE REPETE",
                MAIS_DE_UMA_VEZ: "MAIS DE UMA VEZ",
              }[service.repeat]
            }}</strong>
          </td>
        </tr>
        <tr v-if="service.repeat == 'MAIS_DE_UMA_VEZ'">
          <td>PERIODICIDADE</td>
          <td>
            <strong>{{ service.periodicity }}</strong>
          </td>
        </tr>
        <tr v-if="service.repeat == 'MAIS_DE_UMA_VEZ'">
          <td>QUANTAS VEZES</td>
          <td>
            <strong>{{ service.how_many_times }}</strong>
          </td>
        </tr> -->
        <tr>
          <td>RESPONSÁVEL</td>
          <td>
            <strong>{{
              professionalClassCouncilValue({
                id: service.user_professional_class_council_id,
                name: service.user_name,
                profile: service.user_profile_name,
                office: service.user_office,
                cpf: service.user_cpf,
                value: service.user_professional_class_council_value,
              })
            }}</strong>
          </td>
        </tr>
        <tr>
          <td>DATA DO SERVIÇO</td>
          <td>
            <strong>{{ moment(service.date).format("DD/MM/YYYY") }}</strong>
          </td>
        </tr>
        <tr>
          <td>DATA DO REGISTRO</td>
          <td>
            <strong>{{
              moment(service.created_at).format("DD/MM/YYYY HH:mm:ss")
            }}</strong>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import moment from "moment";

import {
  formatPrice,
  professionalClassCouncilValue,
} from "../../../../lib/format";

export default {
  name: "Details",

  props: {
    service: Object,
  },

  created() {},

  methods: {
    moment,
    formatPrice,
    professionalClassCouncilValue,
  },
};
</script>
